import { render, staticRenderFns } from "./product_area_table.vue?vue&type=template&id=769bb92a&scoped=true"
import script from "./product_area_table.vue?vue&type=script&lang=js"
export * from "./product_area_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769bb92a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('769bb92a')) {
      api.createRecord('769bb92a', component.options)
    } else {
      api.reload('769bb92a', component.options)
    }
    module.hot.accept("./product_area_table.vue?vue&type=template&id=769bb92a&scoped=true", function () {
      api.rerender('769bb92a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/components/product_area_table.vue"
export default component.exports